<!-- 
    描述：评级记录页面
    编辑于     2022-5-20 17:15:41
    编辑人     钱磊
-->
<template>
  <div class="filed-info-layout">
    <div class="common-top" ref="formRef">
      <div class="card-area">
        <el-form :model="recordsData" label-width="130px">
          <el-row>
            <el-col :span="7">
              <el-form-item label="信用对象名称：">
                <div class="text-overflow">
                  {{ recordsData.assName ? recordsData.assName : "-" }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="证件号：">
                <div class="text-overflow">
                  {{ recordsData.assNo ? recordsData.assNo : "-" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label="信用对象类型：">
                <div class="text-overflow">
                  {{ recordsData.assType ? "企业" : "个人" }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="3">
              <el-form-item label="被评价次数：">
                <div class="text-overflow blue">
                  {{ recordsData.assNum }}次
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="参与评价的对象：">
                <div class="text-overflow blue">
                  {{
                    recordsData.relateObjects 
                  }}个
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="总评价分数（百分换算后）："
                class="totalRate"
              >
                <div class="text-overflow blue">
                  {{ recordsData.totalScore  }}分
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="8">
              <el-form-item label="综合评价：">
                <span slot="label">
                  <span class="span-box">
                    <span>综合评价：</span>
                    <img src="@/assets/images/rate.png" alt="" />
                  </span>
                </span>
                <div class="text-overflow">
                  {{
                    recordsData.generalScore 
                  }}分
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <span slot="label">
                  <span class="span-box">
                    <span>好评率：</span>
                    <img src="@/assets/images/rate.png" alt="" />
                  </span>
                </span>
                <div class="text-overflow">
                  {{ recordsData.assRate }}%
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="operation-main">
        <div class="operation-container w-table-layout w-table-page">
          <div class="w-table-content">
            <vxe-table
              :data="tableData"
              :loading="loading"
              :border="true"
              :resizable="true"
              size="small"
              highlight-current-row
              highlight-hover-row
              show-overflow="tooltip"
              show-header-overflow="tooltip"
            >
              <vxe-table-column
                field="serialNo"
                title="流水号"
                min-width="160"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="createDate"
                title="评价时间"
                width="140"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="assProject"
                title="评价项目"
                min-width="160"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="assName"
                title="评价方"
                min-width="160"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="assType"
                title="评价方类型"
                width="100"
                align="center"
                ><template v-slot="{ row }">
                  {{ row.assType ? "企业" : "个人" }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="assRole"
                title="评价方业务角色"
                width="120"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="applyBusName"
                title="业务来源"
                width="100"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="assItems"
                title="评价维度"
                min-width="160"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="itemsNum"
                title="评价维度数量"
                width="110"
                show-overflow
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="totalScore"
                title="评分"
                width="80"
                show-overflow
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="percentScore"
                title="百分换算"
                width="100"
                align="center"
              >
              </vxe-table-column>
              <vxe-table-column
                field="assRate"
                title="评价结果"
                width="100"
                align="center"
              >
                <template v-slot="{ row }">
                  <div v-if="row.evaluation == 1" class="rate-result">
                    <img src="@/assets/images/praise.png" alt="" />好评
                  </div>
                  <div v-else class="rate-result">
                    <img src="@/assets/images/negative.png" alt="" />差评
                  </div>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="w-table-footer">
            <vxe-pager
              size="mini"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="totalResult"
              class="text-center"
              :page-sizes="[10, 20, 50, 100]"
              :layouts="[
                'Total',
                'Sizes',
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'FullJump',
              ]"
              @page-change="handlePageChange"
            >
            </vxe-pager>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { selRecordPageList } from "api/modules/assessment-system/PersonalCredit";
export default {
  data() {
    return {
      recordsData: {}, //评价汇总
      pageSize: 10,
      currentPage: 1,
      totalResult: 0,
      tableData: [], //评价记录列表
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取评级记录数据
    getData() {
      let params = {
        beAssId: this.$route.query.id,
        beAssType: this.$route.query.assType,
        current: this.currentPage,
        size: this.pageSize,
      };
      selRecordPageList(params).then((res) => {
        if (res.operationCode === 1) {
          this.recordsData = res.data.summary;
          this.tableData = res.data.pageList.records;
          this.totalResult = parseInt(res.data.pageList.total);
          this.tableData.forEach((item) => {
            let _item = this.yyyw.filter((val) => {
              return val.value == item.resource;
            });
            item.applyBusName = _item[0].sname; //评价应用码表转名称
          });
        }
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.getData();
    },
  },
  computed: {
    ...mapState("dict", {
      yyyw: (state) => state.yyyw,
      pjwd: (state) => state.pjwd,
    }),
  },
};
</script>

<style lang='less' scoped>
.filed-info-layout {
  .common-top {
    padding: 20px 0;
    .el-form-item {
      margin-bottom: 0;
    }
    .blue {
      color: #0000ff;
    }
    .totalRate /deep/ .el-form-item__label {
      width: 200px !important;
    }
    .comprehensive img {
      float: left;
    }
    .span-box {
      display: inline-block;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: -35px;
      }
    }
    .rate-result {
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>